import { BREAKPOINT } from '@ab-core/breakpoints';
import { ROUTES } from '@ab-core/functions';
import { useIsMobile } from '@ab-core/functions/useIsMobile';
import { isLoggedIn } from '@ab-core/hooks';
import { getTestIdProp } from '@ab-core/testing';
import type { FC } from 'react';
import React from 'react';
import type { ScalableStyle } from '../../scalableStyles';
import { AdditionalLink } from './additionalLink';
import { StyledAdditionalLinksContainer } from './styled';

export type AdditionalLinksContainerStyleType = ScalableStyle<{
    isVisible: boolean;
}>;

export type AdditionalLinksContainerProps = {
    hasAlternatives?: boolean;
    hasAccessories?: boolean;
    sku?: string;
};

export const AdditionalLinksContainer: FC<AdditionalLinksContainerProps & AdditionalLinksContainerStyleType> = (
    props
) => {
    const { hasAlternatives, hasAccessories, sku, scalableStyle } = props;
    const isUserLoggedIn = isLoggedIn();
    const isMobile = useIsMobile(BREAKPOINT.SM);

    if (!scalableStyle?.isVisible) {
        return <></>;
    }

    const showAlternatives = isUserLoggedIn && hasAlternatives;
    const showAccessories = hasAccessories;

    if (isMobile && !showAlternatives && !showAccessories) {
        return <></>;
    }

    return (
        <>
            <StyledAdditionalLinksContainer {...getTestIdProp('product-card-additional-links-container')}>
                <AdditionalLink
                    exists={showAlternatives}
                    iconName="RotatingArrow"
                    text="Alternativen"
                    to={`${ROUTES.PRODUCTPAGE}/${sku}#alternativen`}
                />
                <AdditionalLink
                    exists={showAccessories}
                    iconName="Accessories"
                    text="Zubehör"
                    to={`${ROUTES.PRODUCTPAGE}/${sku}#zubehoer`}
                />
            </StyledAdditionalLinksContainer>
        </>
    );
};
